export interface Filter {
  key: string;
  name: string;
  label: string;
  options: string[];
  defaultOption?: string;
}

export const TRIM_FILTER = 'TRIM_FILTER';
